import { enumLockStatus } from "../constants";

export function PositionLocked(lockStatus) {
  return (
    lockStatus == enumLockStatus.positionLocked || lockStatus == enumLockStatus.contentPosLocked
  );
}
